<div class="ts1-v3-form-summary-modal w-full">
	@for (group of candidateGroups; track group.candidateId) {
		<div class="ts1-v3-form-summary-modal__group">
			<button type="button" class="ts1-v3-form-summary-modal__group-header" (click)="toggleGroupExpanded(group)">
				<div class="ts1-v3-form-summary-modal__group-name-row">
					<span class="ts1-v3-form-summary-modal__group-name">{{ group.candidateName }}</span>
				</div>
				<mat-icon class="ts1-v3-form-summary-modal__group-chevron">
					{{ group.expanded ? "expand_less" : "expand_more" }}
				</mat-icon>
			</button>

			@if (group.expanded) {
				<div class="ts1-v3-form-summary-modal__group-body">
					@if (group.comments.length === 0) {
						<div class="ts1-v3-form-summary-modal__empty text-grey-40">No comments.</div>
					} @else {
						<div class="ts1-v3-form-summary-modal__list">
							@for (comment of group.comments; track commentRowKey(comment, $index); let rowIndex = $index) {
								@if (isRowEditable(comment, rowIndex)) {
									<div class="ts1-v3-form-summary-modal__row ts1-v3-form-summary-modal__row--editing">
										<div class="ts1-v3-form-summary-modal__row-meta">
											<span class="ts1-v3-form-summary-modal__segment ts1-v3-form-summary-modal__segment--candidate">
												@if (comment?.ob !== "REPEAT") {
													[
													@if (getCommentCandidateLabel(comment); as candidateLabel) {
														<span [class]="getCommentCandidateLabelClass(comment)">{{ candidateLabel }}</span>
													}
													@if (
														getCommentCandidateLabel(comment) &&
														(comment.candidateRole === CANDIDATE_ROLE.PF || comment.candidateRole === CANDIDATE_ROLE.PM)
													) {
														<span class="text-grey-60"> · </span>
													}
													@if (comment.candidateRole === CANDIDATE_ROLE.PF) {
														<span class="text-purple-90">PF</span>
													}
													@if (comment.candidateRole === CANDIDATE_ROLE.PM) {
														<span class="text-purple-90">PM</span>
													}
													]
												}
											</span>
											<span class="ts1-v3-form-summary-modal__segment ts1-v3-form-summary-modal__segment--maneuver">
												{{ maneuverSegmentLabel(comment) }}
											</span>
											<span class="ts1-v3-form-summary-modal__segment ts1-v3-form-summary-modal__segment--status">
												@if (comment?.isManeuverOutcome) {
													@if (comment?.remarks) {
														<span [class]="getOutcomeRateClass(comment.rate)">{{ comment.remarks }}</span>
													}
												} @else if (comment?.isTemCompetencyOutcome) {
													@if (reviewLayout) {
														<span>{{ summaryCompetencyStatusLabel(comment) }}</span>
													} @else {
														<span class="text-teal">{{ temSafetyOutcomeLabel }}</span>
													}
													@if (comment?.remarks) {
														<span [class]="getOutcomeRateClass(comment.rate)">{{
															" { " + comment.remarks + " }"
														}}</span>
													}
												} @else if (comment?.ob === "REPEAT") {
													<span class="text-yellow">{{ comment?.ob }}</span>
												} @else if (comment?.ob !== "TEM") {
													<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
														{{ comment?.ob }}
													</span>
													@if (comment?.action != null) {
														<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
															{{ comment?.action ? " { added }" : " { removed }" }}
														</span>
													}
												}
											</span>
										</div>
										<span
											class="ts1-v3-form-summary-modal__segment ts1-v3-form-summary-modal__segment--comment ts1-v3-form-summary-modal__segment--comment-editing normal-case"
										>
											<div class="ts1-v3-form-summary-modal__edit-comment">
												<div class="ts1-v3-form-summary-modal__edit-comment-body">
													<textarea
														[formControl]="addObComments"
														class="ts1-v3-form-summary-modal__edit-textarea border-bg-grey-20 normal-case"
													></textarea>
													<p class="ts1-v3-form-summary-modal__edit-count text-right normal-case">
														<span class="text-grey-90 text-[10px]">({{ addObComments.value.length }})</span>
													</p>
													<app-comment-ai-assist-toolbar
														[commentControl]="addObComments"
														(replace)="saveComment(comment, rowIndex)"
													></app-comment-ai-assist-toolbar>
												</div>
											</div>
										</span>
									</div>
								} @else {
									<div class="ts1-v3-form-summary-modal__row">
										<span class="ts1-v3-form-summary-modal__segment ts1-v3-form-summary-modal__segment--candidate">
											@if (comment?.ob !== "REPEAT") {
												[
												@if (getCommentCandidateLabel(comment); as candidateLabel) {
													<span [class]="getCommentCandidateLabelClass(comment)">{{ candidateLabel }}</span>
												}
												@if (
													getCommentCandidateLabel(comment) &&
													(comment.candidateRole === CANDIDATE_ROLE.PF || comment.candidateRole === CANDIDATE_ROLE.PM)
												) {
													<span class="text-grey-60"> · </span>
												}
												@if (comment.candidateRole === CANDIDATE_ROLE.PF) {
													<span class="text-purple-90">PF</span>
												}
												@if (comment.candidateRole === CANDIDATE_ROLE.PM) {
													<span class="text-purple-90">PM</span>
												}
												]
											}
											@if (rowIndex === 0) {
												<button
													type="button"
													class="ts1-v3-form-summary-modal__col-sort"
													[class.ts1-v3-form-summary-modal__col-sort--active]="isSortActive(group, 'candidate')"
													(click)="onSortColumn(group, 'candidate')"
													aria-label="Sort by candidate and role"
												>
													<span class="ts1-v3-form-summary-modal__sort-icon" aria-hidden="true">
														<span
															class="ts1-v3-form-summary-modal__sort-icon-chevron ts1-v3-form-summary-modal__sort-icon-chevron--up"
														></span>
														<span
															class="ts1-v3-form-summary-modal__sort-icon-chevron ts1-v3-form-summary-modal__sort-icon-chevron--down"
														></span>
													</span>
												</button>
											}
										</span>
										<span class="ts1-v3-form-summary-modal__segment ts1-v3-form-summary-modal__segment--maneuver">
											<span>{{ maneuverSegmentLabel(comment) }}</span>
											@if (rowIndex === 0) {
												<button
													type="button"
													class="ts1-v3-form-summary-modal__col-sort"
													[class.ts1-v3-form-summary-modal__col-sort--active]="isSortActive(group, 'maneuver')"
													(click)="onSortColumn(group, 'maneuver')"
													aria-label="Sort by maneuver"
												>
													<span class="ts1-v3-form-summary-modal__sort-icon" aria-hidden="true">
														<span
															class="ts1-v3-form-summary-modal__sort-icon-chevron ts1-v3-form-summary-modal__sort-icon-chevron--up"
														></span>
														<span
															class="ts1-v3-form-summary-modal__sort-icon-chevron ts1-v3-form-summary-modal__sort-icon-chevron--down"
														></span>
													</span>
												</button>
											}
										</span>
										<span class="ts1-v3-form-summary-modal__segment ts1-v3-form-summary-modal__segment--status">
											<span class="ts1-v3-form-summary-modal__status-text">
												@if (comment?.isObservationComment) {
													<span>{{ comment?.ob }}</span>
												} @else if (comment?.isManeuverOutcome) {
													@if (comment?.remarks) {
														<span [class]="getOutcomeRateClass(comment.rate)">{{ comment.remarks }}</span>
													}
												} @else if (comment?.isTemCompetencyOutcome) {
													@if (reviewLayout) {
														<span>{{ summaryCompetencyStatusLabel(comment) }}</span>
													} @else {
														<span class="text-teal">{{ temSafetyOutcomeLabel }}</span>
													}
													@if (comment?.remarks) {
														<span [class]="getOutcomeRateClass(comment.rate)">{{
															" { " + comment.remarks + " }"
														}}</span>
													}
												} @else if (comment?.ob === "REPEAT") {
													<span class="text-yellow">{{ comment?.ob }}</span>
												} @else if (comment?.ob !== "TEM") {
													@if (comment?.isReset || comment?.lastActionDisabled || comment?.isDisabled) {
														<span class="text-yellow">{{ comment?.ob }}</span>
													} @else {
														<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
															{{ comment?.ob }}
														</span>
													}
													@if (comment?.isReset) {
														<span class="text-yellow">{{ " { Undo }" }}</span>
													} @else if (comment?.lastActionDisabled) {
														<span class="text-yellow">{{ " { Undo N/A }" }}</span>
													} @else if (comment?.isDisabled) {
														<span class="text-yellow">{{ " { N/A }" }}</span>
													} @else if (comment?.action != null) {
														<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
															{{ comment?.action ? " { added }" : " { removed }" }}
														</span>
													}
												}
											</span>
											@if (rowIndex === 0) {
												<button
													type="button"
													class="ts1-v3-form-summary-modal__col-sort"
													[class.ts1-v3-form-summary-modal__col-sort--active]="isSortActive(group, 'competency')"
													(click)="onSortColumn(group, 'competency')"
													aria-label="Sort by OB or outcome"
												>
													<span class="ts1-v3-form-summary-modal__sort-icon" aria-hidden="true">
														<span
															class="ts1-v3-form-summary-modal__sort-icon-chevron ts1-v3-form-summary-modal__sort-icon-chevron--up"
														></span>
														<span
															class="ts1-v3-form-summary-modal__sort-icon-chevron ts1-v3-form-summary-modal__sort-icon-chevron--down"
														></span>
													</span>
												</button>
											}
										</span>
										<span
											class="ts1-v3-form-summary-modal__segment ts1-v3-form-summary-modal__segment--comment normal-case"
										>
											@if (hasInstructorComment(comment)) {
												<span class="ts1-v3-form-summary-modal__comment-text">{{ comment.instructorComment }}</span>
											} @else if (isMissingRequiredComment(comment)) {
												<button
													type="button"
													class="ts1-summary-missing-comment-badge ts1-summary-missing-comment-badge--action"
													(click)="editComment(comment, rowIndex)"
													aria-label="Add required comment"
												>
													<mat-icon class="ts1-summary-missing-comment-badge__icon" aria-hidden="true">
														error_outline
													</mat-icon>
													<span>Comment required</span>
												</button>
											}
										</span>
										<span class="ts1-v3-form-summary-modal__segment ts1-v3-form-summary-modal__segment--actions">
											@if (
												comment?.ob !== "REPEAT" &&
												!comment?.isReset &&
												!comment?.lastActionDisabled &&
												!comment?.isDisabled &&
												canEditSummaryComment(comment)
											) {
												<button
													type="button"
													class="ts1-v3-form-summary-modal__action-btn flex size-6 shrink-0 items-center justify-center rounded-sm text-center"
													(click)="editComment(comment, rowIndex)"
													aria-label="Edit comment"
												>
													<mat-icon class="text-xl text-purple-90">edit</mat-icon>
												</button>
											}
											@if (
												comment?.ob !== "REPEAT" &&
												!comment?.isReset &&
												!comment?.lastActionDisabled &&
												!comment?.isDisabled &&
												canDeleteSummaryComment(comment)
											) {
												<button
													type="button"
													class="ts1-v3-form-summary-modal__action-btn flex size-6 shrink-0 items-center justify-center rounded-sm text-center"
													(click)="deleteComment(comment, rowIndex)"
													aria-label="Delete comment"
												>
													<mat-icon class="text-xl text-purple-90">delete</mat-icon>
												</button>
											}
										</span>
									</div>
								}
							}
						</div>
					}
				</div>
			}
		</div>
	}
</div>
